import {
    Divider,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
  } from "@chakra-ui/react";
  import React, { useEffect, useState } from "react";
  
  import Form from "react-bootstrap/Form";
  import Col from "react-bootstrap/Col";
  import Row from "react-bootstrap/Row";
  import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import PaymentDetailInfo from "./components/paymentDetailsInfo";
  



  const DataRow = ({ label, value, type }) => {
    return (
      <>
          <Form.Label>{label}</Form.Label>
      {type === 'Amount' 
      ?
      <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">₹</span> </InputGroup.Text>
        <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
        disabled
      />
      </InputGroup>
      :
      <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? value : " "}
        disabled
      />
      }
      </>
    );
  };
  
  const EmbrillProfileInfoModel = ({ openInfoModal, closeInfoModal, selectedData }) => {
   
    const [selectedItem, setSelectedItem] = useState(selectedData);  
    const [activeTab, setActiveTab] = useState("information");
  
    useEffect(() => {
      setSelectedItem(selectedData);
    }, [selectedData]);
  
    return (
      <div>
        <Modal
          isOpen={openInfoModal}
          onClose={closeInfoModal}
          size="xl"
          className="modal-main"
        >
          <ModalOverlay />
          <ModalContent top="0" // Position it at the top
           margin="0 auto" // Center it horizontally
           bottom="0"
           className="info-model">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                <span>Organization Bank Information</span>
              </ModalHeader>
              <ModalCloseButton  />
            </div>
            <ModalBody>
              <Form className="addForm">
                <Tabs
                  id="justify-tab-example1"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className=""
                  justify
                >
                  <Tab
                    eventKey="information"
                    title="Information"
                    className="main-tab-item"
                  >
                    <div className="card">
                     <h5 className="heading-h5">Bank Details</h5>
            
            <Row className="info-row">
              
                <Col>
                  <DataRow
                    label="Account Number"
                    value={selectedItem?.acNo}
                  />
                </Col>
                <Col>
                  <DataRow
                    label="IFSC Code"
                    value={selectedItem?.ifc}
                  />
                </Col>    
              </Row>
              <Row className="info-row">
             
                <Col>
                  <DataRow
                    label="Bank Name"
                    value={selectedItem?.bnk}
                  />
                </Col>
                <Col>
                  <DataRow
                    label="Branch Name"
                    value={selectedItem?.bch}
                  />
                </Col>
    
              </Row>
                    <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">Bank Person Contact Details</h5>
            
                    <Row className="info-row">
                      
                        <Col>
                          <DataRow
                            label="Contact Person"
                            value={selectedItem?.cnctPsn}
                          />
                        </Col>
                        <Col></Col>
            
                      </Row>
                      <Row className="info-row">
                      <Col>
                          <DataRow
                            label="Email"
                            value={selectedItem?.mail}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="phone"
                            value={selectedItem?.ph}
                          />
                        </Col>
            
                      </Row>
                      <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                     <PaymentDetailInfo selectedItem={selectedItem}/>
                   </div>
                     

                  </Tab>
                 <Tab
                  eventKey=""
                  title=""
                  disabled
                  className="main-tab-item"
                 >

                 </Tab>
                </Tabs>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    );
  };
  
  export default EmbrillProfileInfoModel;
  